(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["email-popup"] && !Shopify.designMode) return;
  try {
    (function () {
  var popup = document.querySelector('[data-sc-popup]');
  if (!popup || popup.dataset.ready) return;
  popup.dataset.ready = 'true';
  var path = window.location.pathname;
  if (/\/(cart|checkout|checkouts|account|orders)(\/|$)/.test(path)) return;
  var KEY = 'sc_popup_v2';
  var REGISTERED = 'sc_popup_registered';
  var SESSION = 'sc_popup_session';
  var cooldown = 7 * 86400000;
  function read(store, key) { try { return window[store].getItem(key); } catch (e) { return null; } }
  function save(store, key, value) { try { window[store].setItem(key, value); } catch (e) {} }
  var previous = Number(read('localStorage', KEY)) || 0;
  if (read('localStorage', REGISTERED) || read('sessionStorage', SESSION) || (previous && Date.now() - previous < cooldown)) return;
  var form = popup.querySelector('[data-sc-optin]');
  var phone = popup.querySelector('[data-sc-phone]');
  var error = popup.querySelector('[data-sc-error]');
  var submit = popup.querySelector('[data-sc-submit]');
  var code = popup.querySelector('[data-sc-code]');
  var card = popup.querySelector('.sc-popup__card');
  var submitText = submit.textContent;
  var panels = '.cart-drawer.is-open, .cart-drawer[aria-hidden="false"], .mobile-drawer.is-open, .search-overlay.is-open, .quick-view.is-open, .drawer.active, #jack-chat.on, dialog[open]';
  var shown = false;
  var previousFocus = null;
  var ownLock = false;
  var activeTime = 0;
  var lastTick = Date.now();
  var mobile = window.matchMedia('(hover: none), (pointer: coarse)');
  var productSeen = false;
  var interacted = false;
  var maxY = window.scrollY;
  var lastY = maxY;
  var upStart = maxY;
  var upAt = Date.now();
  function blocked() {
    return document.hidden || !!document.querySelector(panels) || !!document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
  }
  function show() {
    if (shown || blocked() || read('localStorage', REGISTERED) || read('sessionStorage', SESSION)) return;
    shown = true;
    previousFocus = document.activeElement;
    ownLock = !document.documentElement.classList.contains('is-locked');
    popup.hidden = false;
    document.documentElement.classList.add('is-locked');
    save('localStorage', KEY, String(Date.now()));
    save('sessionStorage', SESSION, '1');
    card.focus({ preventScroll: true });
    clearInterval(timer);
    if (productObserver) productObserver.disconnect();
    document.dispatchEvent(new CustomEvent('sc:exit-offer', { detail: { action: 'shown', device: mobile.matches ? 'touch' : 'desktop' } }));
  }
  function close() {
    if (popup.hidden) return;
    popup.hidden = true;
    if (ownLock && !document.querySelector(panels)) document.documentElement.classList.remove('is-locked');
    if (previousFocus && previousFocus.isConnected && !document.querySelector(panels)) previousFocus.focus({ preventScroll: true });
  }
  popup.querySelectorAll('[data-sc-popup-close]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (event) {
    if (popup.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    var targets = Array.from(card.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]')).filter(function (el) { return el.getClientRects().length > 0; });
    var first = targets[0];
    var last = targets[targets.length - 1];
    if (!first) { event.preventDefault(); card.focus(); return; }
    if (event.shiftKey && (document.activeElement === first || document.activeElement === card)) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || document.activeElement === card)) { event.preventDefault(); first.focus(); }
  });
  var timer = setInterval(function () {
    var now = Date.now();
    if (!document.hidden) activeTime += Math.min(now - lastTick, 1500);
    lastTick = now;
  }, 1000);
  document.addEventListener('visibilitychange', function () { lastTick = Date.now(); lastY = window.scrollY; upStart = lastY; upAt = lastTick; });
  document.addEventListener('pointerdown', function () { interacted = true; }, { passive: true });
  var productObserver = null;
  if ('IntersectionObserver' in window) {
    productObserver = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting && entry.intersectionRatio >= 0.3; })) productSeen = true;
    }, { threshold: 0.3 });
    document.querySelectorAll('[data-exit-product], .product-card, [data-product-gallery]').forEach(function (el) { productObserver.observe(el); });
  }
  window.addEventListener('scroll', function () {
    var y = Math.max(0, window.scrollY);
    var now = Date.now();
    interacted = true;
    maxY = Math.max(maxY, y);
    if (y >= lastY || now - upAt > 1200) { upStart = lastY; upAt = now; }
    if (mobile.matches && activeTime >= 45000 && productSeen && maxY > 500 && y <= 300 && upStart - y >= 180) show();
    lastY = y;
  }, { passive: true });
  document.addEventListener('mouseout', function (event) {
    if (!mobile.matches && interacted && activeTime >= 30000 && !event.relatedTarget && event.clientY <= 0) show();
  });
  var panelObserver = new MutationObserver(function () { if (!popup.hidden && document.querySelector(panels)) close(); });
  document.querySelectorAll('.cart-drawer, .mobile-drawer, .search-overlay, .quick-view, .drawer, #jack-chat, dialog').forEach(function (el) {
    panelObserver.observe(el, { attributes: true, attributeFilter: ['class', 'aria-hidden', 'open'] });
  });
  form.addEventListener('submit', async function (event) {
    event.preventDefault();
    if (submit.disabled) return;
    error.hidden = true;
    var digits = phone.value.replace(/\D/g, '').replace(/^56/, '');
    if (!/^9\d{8}$/.test(digits)) {
      error.textContent = popup.dataset.errorPhone;
      error.hidden = false;
      phone.setAttribute('aria-invalid', 'true');
      phone.focus();
      return;
    }
    phone.removeAttribute('aria-invalid');
    submit.disabled = true;
    submit.textContent = popup.dataset.sending;
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 15000);
    try {
      var response = await fetch('https://wsp-sneakclean.vercel.app/api/optin', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: '56' + digits, brand: 'sneakclean' }), signal: controller.signal
      });
      if (!response.ok) throw new Error('optin');
      var data = await response.json();
      if (!data.ok || typeof data.codigo !== 'string' || !data.codigo.trim()) throw new Error('code');
      code.textContent = data.codigo;
      popup.querySelector('[data-sc-form-state]').hidden = true;
      popup.querySelector('[data-sc-success-state]').hidden = false;
      card.setAttribute('aria-labelledby', 'sc-exit-success');
      var title = popup.querySelector('[data-sc-success-title]');
      title.id = 'sc-exit-success';
      if (!popup.hidden) title.focus({ preventScroll: true });
      save('localStorage', REGISTERED, '1');
      document.dispatchEvent(new CustomEvent('sc:exit-offer', { detail: { action: 'registered' } }));
    } catch (e) {
      error.textContent = popup.dataset.errorRequest;
      error.hidden = false;
    } finally {
      clearTimeout(timeout);
      submit.disabled = false;
      submit.textContent = submitText;
    }
  });
  popup.querySelector('[data-sc-copy]').addEventListener('click', async function () {
    var status = popup.querySelector('[data-sc-copy-status]');
    try { await navigator.clipboard.writeText(code.textContent.trim()); status.textContent = popup.dataset.copied; }
    catch (e) { status.textContent = popup.dataset.copyError; }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
